import type { TableColumnsType } from 'antd';
import { DataTypeReportFunctions } from 'store/ducks/Reportings/types';

export const columns: TableColumnsType<DataTypeReportFunctions> = [
  {
    title: 'Name of the financial entity',
    width: 100,
    dataIndex: 'entity_name',
    key: 'entity_name',
    fixed: 'left',
  },
  {
    title: 'Function',
    width: 100,
    dataIndex: 'function_name',
    key: 'function_name',
  },
  {
    title: 'Function Description',
    width: 100,
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: 'Criticality assessment',
    width: 100,
    dataIndex: 'criticality_assessment',
    key: 'criticality_assessment',
  },
  {
    title: 'Reasons for criticality',
    width: 100,
    dataIndex: 'reasons_for_criticality',
    key: 'reasons_for_criticality',
  },
  {
    title: 'Licensed activity',
    width: 100,
    dataIndex: 'licensed_activity',
    key: 'licensed_activity',
  },
  {
    title: 'Date of last assessment',
    width: 100,
    dataIndex: 'date_of_last_assessment',
    key: 'date_of_last_assessment',
  },
  {
    title: 'Recovery point objective',
    width: 100,
    dataIndex: 'recovery_point_objective',
    key: 'recovery_point_objective',
  },
  {
    title: 'Recovery time objective',
    width: 100,
    dataIndex: 'recovery_time_objective',
    key: 'recovery_time_objective',
  },
];
